import { PresetObj } from "../../api-entities/PresetArea";
import { Action } from "../actions/All";
import { ActionType } from "../ActionTypes";
import { Announcement } from "../../entities/Announcement";

export interface DataState {
	loadedAt?: number;

	/**
	 * All preset areas, keyed by their name.
	 */
	presetArea: Map<string, PresetObj>;

	/**
	 * Short form terms and conditions for archive orders, in raw html.
	 */
	archiveTerms: string;

	/**
	 * All current announcements. Refreshed more frequently than other state objects.
	 */
	announcements: Announcement[];
}

/**
 * The state of the data store on app start up.
 */
export const initial: DataState = {
	presetArea: new Map(),
	archiveTerms: "",
	announcements: []
};


export const dataReducer = (state: DataState = initial, action: Action): DataState => {
	switch (action.type) {
		case ActionType.SET_AREA: {
			return {
				...state,
				presetArea: new Map(action.area.map(a => [a.name, a] as [string, PresetObj]))
			};
		}


		case ActionType.SET_ARCHIVE_TERMS: {
			return {
				...state,
				archiveTerms: action.terms
			};
		}

		case ActionType.SET_ANNOUNCEMENTS: {
			return {
				...state,
				announcements: action.announcements
			};
		}

		case ActionType.DATA_LOADED: {
			return {
				...state,
				loadedAt: action.loadedAt
			};
		}

		default:
			return state;
	}
};
